import { TextInput } from '@/components/ui/text-input';
import { UserAvatar } from '@/components/ui/user-avatar';
import { cn } from '@/lib/utils';
import { useAppTheme } from '@/providers/theme-provider';
import { Ionicons } from '@expo/vector-icons';
import { forwardRef, useState } from 'react';
import {
  ActivityIndicator,
  Pressable,
  type TextInput as RNTextInput,
  View,
} from 'react-native';


const MAX_LENGTH = 500;
interface CommentInputBarProps {
  avatarUrl: string | null | undefined;
  value: string;
  onChangeText: (text: string) => void;
  onSend: () => void;
  isSending: boolean;
}

export const CommentInputBar = forwardRef<RNTextInput, CommentInputBarProps>(
  ({ avatarUrl, value, onChangeText, onSend, isSending }, ref) => {
    const theme = useAppTheme();
    const [focused, setFocused] = useState(false);

    const canSend = value.trim().length > 0 && !isSending;

    return (
      <>
        <View className="flex-row items-center mt-3 gap-2 px-4">
          <UserAvatar uri={avatarUrl} size={28} decorative />
          <TextInput
            ref={ref}
            value={value}
            onChangeText={onChangeText}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
            // onSelectionChange={handleSelectionChange}
            placeholder="Add a comment..."
            maxLength={MAX_LENGTH}
            multiline
            multilineMinHeight={20}
            size="sm"
            containerClassName="flex-1"
            inputContainerClassName={cn(
              'bg-surface-secondary rounded-lg px-3 min-h-9',
              focused ? 'border-primary' : 'border-transparent'
            )}
            inputStyle={{
              maxHeight: 80,
              paddingVertical: 6,
              fontSize: 14,
            }}
          />
          <Pressable
            onPress={onSend}
            disabled={!canSend}
            style={{ opacity: canSend ? 1 : 0.4 }}
            hitSlop={{ top: 12, bottom: 12, left: 12, right: 12 }}
            accessibilityRole="button"
            accessibilityLabel="Send comment"
          >
            {isSending ? (
              <ActivityIndicator size="small" color={theme.colors.primary} />
            ) : (
              <Ionicons
                name="send"
                size={20}
                className={cn(!value.trim() ? 'text-muted-foreground' : 'text-primary')}
              />
            )}
          </Pressable>
        </View>
      </>
    );
  }
);

CommentInputBar.displayName = 'CommentInputBar';
